export default __webpack_public_path__ + "static/media/intro-os.a577c5e3.jpg";